import React from 'react';

import Card from './Card';
import Button from './Button';
import classes from './ErrorModal.module.css';

const ErrorModal = (props) => {
  return (
    <div>
      <div className={classes.backdrop} />
      <Card className={classes.modal}>
        <header className={classes.header}></header>
        <div className={classes.content}>
            <div class="embed-responsive embed-responsive-4by3">
                <iframe id="videoContainer" class="embed-responsive-item" src={props.videoId}></iframe>
            </div>
        </div>
        <footer className={classes.actions}>
          <Button onClick={props.onConfirm}>Close</Button>
        </footer>
      </Card>
    </div>
  );
};

export default ErrorModal;
